import { useFetcher } from "@remix-run/react";
import { Button } from "./ui/button";
import { BookmarkIcon } from "lucide-react";
import { BookmarkFilledIcon } from "@radix-ui/react-icons";
import type { Job } from "~/db/types";

export function SaveButton({
  job,
  isCandidate,
}: {
  job: Job & { saved: number | null };
  isCandidate?: boolean;
}) {
  const saveJobFetcher = useFetcher();

  const isSaving =
    saveJobFetcher.formData?.get("_intent") === "save" && isCandidate;
  const isRemoving =
    saveJobFetcher.formData?.get("_intent") === "remove" && isCandidate;

  return (
    <div>
      <saveJobFetcher.Form method="post">
        <input
          type="hidden"
          name="_intent"
          value={`${job.saved ? "remove" : "save"}`}
        />

        {/* Desktop Version */}
        <Button variant={"link"} name="jobId" type="submit" value={job.id}>
          {(job.saved || isSaving) && !isRemoving ? (
            <BookmarkFilledIcon
              onClick={(ev) => {
                ev.stopPropagation();
              }}
              className="w-6 h-6"
            />
          ) : (
            <BookmarkIcon
              onClick={(ev) => {
                ev.stopPropagation();
              }}
              className="w-6 h-6"
            />
          )}
        </Button>

        {/* Mobile Version - Disabled for now */}
        {/* <Button
          variant={"outline"}
          className="md:hidden"
          name="jobId"
          type="submit"
          value={job.id}
        >
          {`${job.saved ? "Saved" : "Save"}`}

          {job.saved ? (
            <BookmarkFilledIcon
              color="rgb(77 124 15)"
              onClick={(ev) => {
                ev.stopPropagation();
              }}
              className="w-6 h-6 ml-4"
            />
          ) : (
            <BookmarkIcon
              onClick={(ev) => {
                ev.stopPropagation();
              }}
              className="w-6 h-6 ml-4"
            />
          )}
        </Button> */}
      </saveJobFetcher.Form>
    </div>
  );
}
